var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-option-container"},[_c('span',{staticClass:"footer-option-label"},[_vm._v(_vm._s(_vm.$t("common.currency"))+":")]),_c('v-select',{staticClass:"footer-option-select",attrs:{"items":_vm.currencies},model:{value:(_vm.currencySelected),callback:function ($$v) {_vm.currencySelected=$$v},expression:"currencySelected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }